/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CountryItem } from '../models/CountryItem';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CountrySelectorService {
    /**
     * Get All countries withStates
     * Get All countries withStates
     * @returns CountryItem Successfully update user time zone
     * @throws ApiError
     */
    public static getCountriesWithStates(): CancelablePromise<Array<CountryItem>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/country',
        });
    }
}
